import SearchResult from "./SearchResult";


export const ExpandedSearch = ({ results, onSelect }) => {
  return (

    <div className="results-list">
      {results
        .filter(result => !result.name.toLowerCase().includes("path"))
        .map(result => (
          <SearchResult onSelect={onSelect} result={result.name} key={result.id} />
        ))}
    </div>

  );
};

export default ExpandedSearch;
